import LocationSwitcher from './LocationSwitcher';

export default LocationSwitcher;



// WEBPACK FOOTER //
// ./src/components/LocationSwitcher/index.js